import { createSlice } from '@reduxjs/toolkit';

export const matriculation = createSlice({
    name: 'matriculation',
    initialState: {
        data: ['beforeFetch']
    },
    reducers: {
      fetchSuccess(state, action) {
        const { payload } = action;
        state.data = payload;
      },
  },
}).reducer;